import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
    breadcrumbList: {
      item_group: '首页',
      item: '',
      item1: '',
      item2: '',
      path:'',
      itemPath:''
    },
    //进件弹窗
    editOrAddInfo:{
      type:'',
      mchId:'',
      orgId:'',
      storeId:'',
      compName:'',
      smpayId:'',

    },
    // 显示弹窗
    showWhichPop:{

    }
	},
	mutations: {
    incomOper(state,option){
       state.editOrAddInfo.type = option.type
       state.editOrAddInfo.mchId = option.mchId
       state.editOrAddInfo.orgId = option.orgId
       state.editOrAddInfo.compName = option.compName
       state.editOrAddInfo.storeId = option.storeId
       state.editOrAddInfo.chgUserId = option.chgUserId
       state.editOrAddInfo.incomState = option.incomState
       state.editOrAddInfo.smpayId = option.smpayId
    },
    showPop(state,option){
       state.showWhichPop.isShowShMsg = option.isShowShMsg
       state.showWhichPop.optionPayShow = option.optionPayShow
    }
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js